import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var justify_stretch_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M4 4H5.5V20H4V4ZM7 10L17 10V14L7 14V10ZM20 4H18.5V20H20V4Z" }) });
export {
  justify_stretch_default as default
};
//# sourceMappingURL=justify-stretch.js.map
